import React from "react"
import ReactWOW from "react-wow"
import { useStaticQuery, graphql } from "gatsby"
import MiniContactForm from "../Index/MiniContactFormRedesign"
import Badges from "../PartnerBadgeSections/Roostbadge"
import SourceIdentifier from "../Common/SourceIdentifier"
import { Link } from "gatsby"

const RoostBanner = props => {
  const responseData = useStaticQuery(graphql`
    query GetPartnerOORatesQuery {
      allStrapiRateCards(
        filter: {
          Rate_Name: {
            in: ["Interest_Rate_OO", "LVR_OO", "Comparison_Rate_OO"]
          }
        }
      ) {
        edges {
          node {
            Rate_Name
            Rate_Value
          }
        }
      }
    }
  `)
  console.log("data", responseData)
  console.log("props", props)

  const interestRateOO =
    responseData.allStrapiRateCards.edges.find(
      edge => edge.node.Rate_Name === "Interest_Rate_OO"
    ).node.Rate_Value || "N/A"

  const comparisonRateOO =
    responseData.allStrapiRateCards.edges.find(
      edge => edge.node.Rate_Name === "Comparison_Rate_OO"
    ).node.Rate_Value || "N/A"

  const lvrOO =
    responseData.allStrapiRateCards.edges.find(
      edge => edge.node.Rate_Name === "LVR_OO"
    ).node.Rate_Value || "N/A"

  console.log(props.partner.Code)
  const partnerName = SourceIdentifier(props.partner.Code)

  return (
    <div className="home-hero-banner-revamp partner-banner">
      <div className="container hero">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-12 my-5">
            <div className="hero-title-wrapper mt-5">
              {/* <ReactWOW delay=".5s" animation="fadeInDown"> */}
              <div className="chevron-up"></div>
              {/* </ReactWOW> */}
              <h1 className="hero-title">
                Home Loans <span className="">Made Simple </span>
                <ReactWOW delay=".5s" animation="fadeInDown">
                  <sup className=""> TM</sup>
                </ReactWOW>
              </h1>
            </div>
            <h2 className="mb-4">Find a better home loan in 5 minutes.</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-5 col-lg-6 mb-4 mb-lg-0">
            {(() => {
              if (props.partner.Code == "Mcgrath") {
                return (
                  <ReactWOW delay=".05s" animation="fadeInUp">
                    <div className="d-flex justify-content-center h-100">
                      <div className="rates-comparison">
                        <Badges parnerBadge={props.partner.logo[0].url} />
                        <div className="">
                          <div className="blue-corona"></div>
                          <div className="row">
                            <div className="col-6 mb-4 mb-lg-0 col-lg-12">
                              <div className="rates-group">
                                <label>Rates from</label>
                                <div className="rate-wrapper">
                                  <h2 className="rate">{interestRateOO}</h2>
                                  <div className="percentage">
                                    <p className="percentage-symbol d-flex flex-column">
                                      %<span>p.a</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-lg-12">
                              <div className="rates-comparison-group">
                                <label>Comparison</label>
                                <div className="rate-wrapper">
                                  <h2 className="rate">{comparisonRateOO}</h2>
                                  <div className="percentage">
                                    <p className="percentage-symbol d-flex flex-column">
                                      %<span>p.a</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="owner-occupied mb-4">
                          <p>Owner occupied | P&I | {lvrOO}% LVR </p>
                        </div>

                        <ReactWOW delay=".05s" animation="fadeInUp">
                          <div className="btn-box">
                            {/* {`${process.env.GATSBY_ENVIRONMENT}` ===
                            "staging" ? (
                              <a
                                href={`${process.env.GATSBY_OLAP_BASE_URL}/?SourceType=${partnerName}`}
                                className="default-btn primary-btn btn-lg mb-2 mr-sm-3 mr-lg-2"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                10 min Home Loan Pre-Approval<span></span>
                              </a>
                            ) : (
                              <a
                                href={`${process.env.GATSBY_OLAP_BASE_URL}/?SourceType=${partnerName}`}
                                className="default-btn primary-btn btn-lg mb-2 mr-sm-3 mr-lg-2"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                10 min Home Loan Pre-Approval<span></span>
                              </a>
                            )} */}
                            <Link
                              to="/book-a-call"
                              className="default-btn mid-width-btn primary-btn btn-lg mb-2 mr-sm-3 mr-lg-2"
                              rel="noopener noreferrer"
                            >
                              Talk to an Expert<span></span>
                            </Link>
                          </div>
                        </ReactWOW>
                      </div>
                    </div>
                  </ReactWOW>
                )
              }
              return null
            })()}
          </div>
          <div className="col-xl-7 col-lg-6">
            <MiniContactForm partner={props.partner.Code} />
          </div>
        </div>
      </div>
      <div className="highlights container pt-5">
        <div className="row d-flex justify-stats">
          <div className="col-lg-4 col-12 my-3">
            <div className="circle-tile-2 p-4">
              <h3>$10+ Billion</h3>
              <p>in home loans settled</p>
            </div>
          </div>

          <div className="col-lg-4 col-12 my-3">
            <div className="circle-tile-2 p-4">
              <h3>27,000+</h3>
              <p>customers served</p>
            </div>
          </div>

          <div className="col-lg-4 col-12 my-3">
            <div className="circle-tile-2 p-4">
              <h3>19 Years</h3>
              <p>of service and counting</p>
            </div>
          </div>

          <div className="col-lg-4 col-12 my-3">
            <div className="circle-tile-2 p-4">
              <h3>8x Winner</h3>
              <p>MFAA &amp; AFG Brokerage of the Year</p>
            </div>
          </div>

          <div className="col-lg-4 col-12 my-3">
            <div className="circle-tile-2 p-4">
              <h3>53+</h3>
              <p>Locations + Apply Online</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoostBanner
